'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



/*****************
 ** WEBPACK FOOTER
 ** ../~/querystring/index.js
 ** module id = 1028
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/querystring/index.js
 ** module id = 1028
 ** module chunks = 1
 **/